// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"6ab5c8dc","545":"37dc319c","629":"c2432f2a","670":"00b9e4cf","993":"18ac3def"}[chunkId] + ".chunk.js";
};